
document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.challenge-cards');

    containers.forEach(container => {
        const intervalTime = parseInt(container.dataset.autoplayInterval) || 5000;
        const navButtons = container.querySelectorAll('.challenge-cards__tab-button');
        const contentPanes = container.querySelectorAll('.challenge-cards__content-pane');
        const imagePanes = container.querySelectorAll('.challenge-cards__image-pane');

        let currentIndex = 0;
        let autoplayTimer = null;
        let isPaused = false;

        const totalTabs = navButtons.length;
        if (totalTabs === 0) return;

        // Function to switch tab
        const switchTab = (index) => {
            // Remove active classes
            navButtons.forEach(btn => {
                btn.classList.remove('active');
                btn.setAttribute('aria-selected', 'false');
            });
            contentPanes.forEach(pane => pane.classList.remove('active'));
            imagePanes.forEach(pane => pane.classList.remove('active'));

            // Add active classes to new index
            if (navButtons[index]) {
                navButtons[index].classList.add('active');
                navButtons[index].setAttribute('aria-selected', 'true');
            }
            if (contentPanes[index]) contentPanes[index].classList.add('active');
            if (imagePanes[index]) imagePanes[index].classList.add('active');

            currentIndex = index;
        };

        // Autoplay Logic
        const startAutoplay = () => {
            if (autoplayTimer) clearInterval(autoplayTimer);
            autoplayTimer = setInterval(() => {
                if (!isPaused) {
                    const nextIndex = (currentIndex + 1) % totalTabs;
                    switchTab(nextIndex);
                }
            }, intervalTime);
        };

        const stopAutoplay = () => {
            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        };

        // Event Listeners for Manual Interaction
        navButtons.forEach((btn, index) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                switchTab(index);
                // Reset timer on manual interaction
                stopAutoplay();
                startAutoplay();
            });
        });

        // Pause on Hover/Focus
        container.addEventListener('mouseenter', () => {
            isPaused = true;
        });

        container.addEventListener('mouseleave', () => {
            isPaused = false;
        });

        container.addEventListener('touchstart', () => {
            isPaused = true;
        }, { passive: true });


        // Intersection Observer to start autoplay only when visible
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startAutoplay();
                } else {
                    stopAutoplay();
                }
            });
        }, { threshold: 0.3 });

        observer.observe(container);
    });
});
